import React from "react";
import { motion } from "framer-motion";
import { Instagram as IgIcon } from "lucide-react";
import { INSTAGRAM, CONFIG } from "../data/content";
import { Reveal, Eyebrow, EASE } from "./Reveal";

export const InstagramSection = () => (
  <section
    id="instagram"
    className="relative bg-[#EFE0C6] py-24 sm:py-36 px-6 sm:px-10 md:px-16"
    data-testid="instagram"
  >
    <div className="max-w-6xl mx-auto">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6">
        <div>
          <Reveal>
            <Eyebrow className="text-[#9C7526]">Instagram</Eyebrow>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-5 font-serif font-medium text-[#21070D] text-4xl sm:text-5xl lg:text-6xl tracking-tight">
              Follow the journey
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.15}>
          <a
            href={CONFIG.instagram}
            target="_blank"
            rel="noreferrer"
            data-testid="instagram-follow-btn"
            className="btn-gold inline-flex items-center gap-2.5 rounded-full px-7 py-3.5 text-xs uppercase tracking-[0.18em] font-semibold"
          >
            <IgIcon size={17} /> {CONFIG.instagramHandle}
          </a>
        </Reveal>
      </div>

      {/* Masonry via CSS columns */}
      <div className="mt-14 columns-2 md:columns-3 gap-4 sm:gap-5 [column-fill:_balance]">
        {INSTAGRAM.map((src, i) => (
          <motion.a
            key={i}
            href={CONFIG.instagram}
            target="_blank"
            rel="noreferrer"
            data-testid={`instagram-post-${i}`}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.7, ease: EASE, delay: (i % 3) * 0.08 }}
            className="group relative mb-4 sm:mb-5 block break-inside-avoid overflow-hidden rounded-2xl"
          >
            <img
              src={src}
              alt={`Instagram post ${i + 1}`}
              className="w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-[#21070D]/0 group-hover:bg-[#21070D]/40 transition-colors duration-500 grid place-items-center">
              <IgIcon
                size={30}
                className="text-[#F4EBD9] opacity-0 scale-75 group-hover:opacity-100 group-hover:scale-100 transition-all duration-500"
              />
            </div>
          </motion.a>
        ))}
      </div>
    </div>
  </section>
);
